import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { createHighlightConfig, getHighlightConfigs, getHighlightTypes } from "./actions";

export const highlightConfigEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = highlightConfigEntityAdapter.getInitialState({
  highlightTypes: [],
  count: 0,
});

export const highlightConfigSlice = createSlice({
  name: "highlightConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHighlightConfigs.fulfilled, (state, action) => {
      if (!action.payload?.error) {
        if (action.meta.arg?.append) {
          highlightConfigEntityAdapter.upsertMany(state, action.payload?.data?.items || []);
        } else {
          highlightConfigEntityAdapter.setAll(state, action.payload?.data?.items || []);
          state.count = action.payload?.data?.totalItems;
        }
      }
    });
    builder.addCase(getHighlightTypes.fulfilled, (state, action) => {
      if (!action.payload?.error) {
        state.highlightTypes = action?.payload?.data?.items || [];
      }
    });
    builder.addCase(createHighlightConfig.fulfilled, (state, action) => {
      if (!action.payload?.error) {
        highlightConfigEntityAdapter.upsertOne(state, action.payload?.data);
      }
    });
  },
});

export default highlightConfigSlice.reducer;
